import { createLogger } from 'redux-logger';

import { compose, applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import actionCreators from './actions';
import rootReducer from './reducers';
import rootSaga from './sagas';

const logger = createLogger({
    collapsed: true,
    level: 'info',
});

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          actionCreators,
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

const enhancer = composeEnhancer(applyMiddleware(sagaMiddleware, logger));

const initialState = {};

export default createStore(rootReducer, initialState, enhancer);

sagaMiddleware.run(rootSaga);
